


// document.addEventListener("DOMContentLoaded", function () {

//   if (window.innerWidth > 768) return; // Mobile only

//   const slider = document.querySelector(
//     "#Slider-template--24369418240305__featured_collection_QiFt4P"
//   );

//   if (!slider) return;

//   const sliderComponent = slider.closest("slider-component");
//   if (!sliderComponent) return;

//   const nextBtn = sliderComponent.querySelector(".slider-button--next");
//   const prevBtn = sliderComponent.querySelector(".slider-button--prev");

//   if (!nextBtn || !prevBtn) return;

//   let interval;
//   let delay = 3000;

//   function startAutoSlide() {
//     interval = setInterval(() => {
//       if (!nextBtn.disabled) {
//         nextBtn.click();
//       } else {
//         // Instead of instant reset → smooth back to start
//         prevBtn.click();
//         setTimeout(() => prevBtn.click(), 300);
//       }
//     }, delay);
//   }

//   function stopAutoSlide() {
//     clearInterval(interval);
//   }

//   // Start
//   startAutoSlide();

//   // Pause on hover
//   sliderComponent.addEventListener("mouseenter", stopAutoSlide);
//   sliderComponent.addEventListener("mouseleave", startAutoSlide);

//   // Pause on touch
//   sliderComponent.addEventListener("touchstart", stopAutoSlide);
//   sliderComponent.addEventListener("touchend", startAutoSlide);

// });


document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 768) return; // Mobile only

  const sliders = document.querySelectorAll("slider-component");

  sliders.forEach((sliderComponent) => {

    const slider = sliderComponent.querySelector(".slider");
    if (!slider) return;

    const nextBtn = sliderComponent.querySelector(".slider-button--next");
    const prevBtn = sliderComponent.querySelector(".slider-button--prev");

    if (!nextBtn || !prevBtn) return;

    let interval;
    let delay = 3000;

    function startAutoSlide() {
      interval = setInterval(() => {
        if (!nextBtn.disabled) {
          nextBtn.click();
        } else {
          // Smooth reset
          prevBtn.click();
          setTimeout(() => prevBtn.click(), 300);
        }
      }, delay);
    }

    function stopAutoSlide() {
      clearInterval(interval);
    }

    startAutoSlide();

    // Pause on hover
    sliderComponent.addEventListener("mouseenter", stopAutoSlide);
    sliderComponent.addEventListener("mouseleave", startAutoSlide);

    // Pause on touch
    sliderComponent.addEventListener("touchstart", stopAutoSlide);
    sliderComponent.addEventListener("touchend", startAutoSlide);

  });

});

